/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import 'ag-grid-enterprise';

import { Period }           from '@/util/period';
import {ICellRenderer, ICellRendererParams} from "ag-grid-community";

/**
 *
 * @class WorkPeriodRenderer
 *
 * @brief cell rendering for "period values"
 *
 * Basically the format is:
 *
 *   P[n]Y[n]M[n]DT[n]H[n]M[n]S
 *
 * we really only need to support P[n]DT[n]H[n]M[n]S; train simulations only run for weeks not months or years.
 *
 * @link https://en.wikipedia.org/wiki/ISO_8601
 * @link https://www.digi.com/resources/documentation/digidocs/90001437-13/reference/r_iso_8601_duration_format.htm
 * @link ftp://ftp.ripe.net/test-traffic/ROOT/delayplots/iso8601.C
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class PeriodRenderer implements ICellRenderer {

  /** agGrid DOM element for display */
  public gui: HTMLElement;

  /** the value being rendered */
  public value: Period   = null;

  public noDays: boolean = false;

  /** E-Z padding */
  public static pad(value: number, size: number = 2) {

    let s: string = String(value);

    while (s.length < (size || 2)) {

      s = `0${s}`;
    }

    return s;
  }

  /** first time creation of the rendered cell. */
  public init(params: ICellRendererParams): void {

    this.gui = document.createElement('div');

    /* render! */

    this.refresh(params);
  }

  /** return the currently rendered DOM */
  public getGui(): HTMLElement {

    return this.gui;
  }

  /** update the rendered DOM */
  public refresh(params: ICellRendererParams): boolean {

    if (typeof params.value === 'undefined') {

      /* grouping row */

      this.gui.innerHTML = `<span></span>`;
      return true;
    }

    this.value         = null;

    if (this.noDays) {

      this.gui.innerHTML = `<span style="color: grey;">HH:MM:SS</span>`;

    } else {

      this.gui.innerHTML = `<span style="color: grey;">DD:HH:MM:SS</span>`;
    }

    if ((typeof params.value === 'undefined') || (params.value === null) || (params.value === '')) {

      return true;
    }


    if (params.value instanceof Period) {

      this.value = params.value;

      if (this.noDays) {

        this.value._days = 0;
      }

      if (this.value._days < 0) {

        this.value._days = 0;
      }

      if (this.value._hours < 0) {

        this.value._hours = 0;
      }

      if (this.value._minutes < 0) {

        this.value._minutes = 0;
      }

      if (this.value._secs < 0) {

        this.value._secs = 0;
      }
    }

    if (!this.value) {

      /* nothing to do */

      return true;
    }

    const d = PeriodRenderer.pad(this.value._days);
    const h = PeriodRenderer.pad(this.value._hours);
    const m = PeriodRenderer.pad(this.value._minutes);
    const s = PeriodRenderer.pad(this.value._secs);

    /* render */

    if (this.noDays) {

      this.gui.innerHTML = `${h}:${m}:${s}`;

    } else {

      this.gui.innerHTML = `${d}:${h}:${m}:${s}`;

    }

    return true;
  }

  /** destructor for rendered DOM */
  public destroy() {

  }

}
